import { Component, Inject,OnInit,NgZone } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { ChangeDetectorRef } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
@Component({
  selector: 'app-all-coupon-set',
  templateUrl: './all-coupon-set.component.html',
  styleUrls: ['./all-coupon-set.component.scss']
})
export class AllCouponSetComponent implements OnInit {

  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: any,private cdr: ChangeDetectorRef,private ngZone: NgZone,private bottomSheetRef: MatBottomSheetRef<AllCouponSetComponent>) {}

  ngOnInit() {
  }


 showToast: boolean = false;

  

 copyToClipboard(couponCode: string): void {
  navigator.clipboard.writeText(couponCode).then(() => {
    this.showToast = true;
    setTimeout(() => {
      this.showToast = false;
    }, 2000); // hide after 2 seconds
  }).catch(err => {
    console.error('Failed to copy text: ', err);
  });
}

close(): void {
  this.bottomSheetRef.dismiss();
}
}
// navigator.clipboard.writeText(couponCode).then(() => {
//   this.showToast = true;
//   setTimeout(() => this.showToast = false, 3000); // Hide after 3 seconds
// }).catch(err => {
//   console.error('Failed to copy:', err);
// });

